export class IncidentHistory{
    incidentsDate:any;
    createdByEmpId: number;
    handleByEmpId: number;
    handleByEmpName:string;
    incidentsByEmpId: number;
    incidentsByHubId: number;
    incidentsContent: string;
    incidentsReason: string;
    incidentsReasonId:number;
    handleContent: string;
    incidentsNote:string;
    statusIncidentId:number;
    quantityBroken:any;
    incidentsByEmpName:any;
    isChangeEmp:boolean;
    isChangeContent:boolean;
    isChangeNote:boolean;
    isChangeReason:boolean;
    dataChange:string;
}